import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from 'src/app/core/services/utility.service';
import { LogCategory, LoggerService, LogPage, LogType } from '../../../core/services/logger.service';
import { ProfileService } from '../../../core/services/profile.service';

@Component({
    selector: 'group-email',
    templateUrl: './group-email.component.html',
    styleUrls: ['./group-email.component.scss'],
    standalone: false
})
export class GroupEmailComponent implements OnInit, OnDestroy {

    public description: string;
    public mailtos: string;

    constructor(        
        private logger: LoggerService,                       
        public activeModal: NgbActiveModal,
        private util: UtilityService,
        public profileService: ProfileService,
    ) {
        this.log("constructor", "", LogCategory.Constructor);        
    }

    public get mailGroups() : string[] {
        return this.util.splitToSize(this.mailtos, ";", 1950); 
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Page, LogPage.People, category);
    }

    ngOnInit(): void {
        this.log("ngOnInit", null, LogCategory.Init); 
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    private sendEmail(recipient) {
        window.location.assign("mailto:" + recipient);
    }
}
